export const fadeTop = {
  hidden: {
    opacity: 0,
    y: '100%',
    transition: {
      duration: 0.5,
      transition: {
        type: 'easeInOut',
      },
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      transition: {
        type: 'easeInOut',
      },
    },
  },
};
